export default {
  settings: {
    languageId: 'en',
  },
  labels: {
    en: {
      'flyover.general.tab': 'General',
      'flyover.feeds.schedules.tab': 'Schedules',
      'flyover.feeds.exportActivityLog.tab': 'Exports',
      'flyover.feeds.schedules.tab.sort.label': 'Sort by:',
      'flyover.feeds.schedules.tab.mostRecent.button': 'Most Recent',
      'flyover.feeds.schedules.empty.title': 'No Schedules Available',
      'flyover.feeds.schedules.empty.message':
        'There are no schedules created yet. You may schedule this feed to start.',
      'flyover.feeds.exportActivityLog.empty.title': 'No Export Activity',
      'flyover.feeds.exportActivityLog.empty.message':
        "Export a feed, and have it delivered to your email. We'll keep track of your exports here.",
      'flyover.feeds.schedules.empty.button': 'Schedule Feed',
      'flyover.feeds.schedules.card.schedule.label': 'Schedule',
      'flyover.feeds.schedules.card.recurrence.label': 'Recurrence',
      'flyover.feeds.schedules.card.nextRun.label': 'Next Run',
      'flyover.schedules.activityLog.tab': 'Activity Log',
      'flyover.schedules.activityLog.empty.title': 'No Runs Available',
      'flyover.schedules.activityLog.empty.message':
        "No logs are available because this schedule hasn't run yet according to the set parameters. Please get in touch with support if you are facing issues.",
      'flyover.schedules.activityLog.empty.button': 'Contact Support',
      'flyover.schedules.activityLog.card.startTime.label': 'Start Time',
      'flyover.schedules.activityLog.card.endTime.label': 'End Time',
      'flyover.schedules.activityLog.card.jobId.label': 'Job ID',
    },
  },
}
